module.exports = __webpack_public_path__ + "img/logo-compose-exact.38ddc050.svg";